import React from 'react';
import SamLibrary from './SamLibrary';

// Seller lens: Discovery reuses the full SAM.gov notice search (200K+ notices)
// with a seller framing. From a promising notice, the seller runs Bid/No-Bid
// (Pipeline tab) to decide whether to pursue.
export default function Discovery() {
  return (
    <div>
      <div style={{
        background: 'linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%)',
        border: '1px solid #e2e8f0', borderRadius: 12, padding: '14px 18px', marginBottom: 18,
      }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#1e293b' }}>Find opportunities worth pursuing</div>
        <div style={{ fontSize: 13, color: '#475569', marginTop: 4 }}>
          Search live federal notices, then run a grounded Bid / No-Bid analysis on the ones that fit.
          Tip: note the NAICS and agency of a promising notice and take it to the Bid / No-Bid tab.
        </div>
      </div>
      <SamLibrary />
    </div>
  );
}
